import DesLibraryMembersListViewModel from 'viewmodel/DesLibraryMembersListViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesLibraryMembersList extends DesBaseCatalogAcc {
    constructor() {
        super(DesLibraryMembersListViewModel);
    }

    get libraryId() {
        return this.getAttribute('library-id') || this.getAttribute('libraryid');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            libraryid: this.libraryId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'libraryid', 'library-id'];
    }
}

if (!window.customElements.get('des-library-members-list')) {
    window.customElements.define('des-library-members-list', DesLibraryMembersList);
}
